import {BASE_TRACK_API_URL} from "@constants/config";
import {apiRequestWithAuth} from "@helpers/query/apiRequestWithAuth";

export interface IUiSettingsChange {
	theme?: string,
	themeSize?: string,
	language?: string,
}

// Set when the language was picked on the sign in page, so the choice is kept for the user once they are in.
export const LANGUAGE_CHOSEN_KEY = 'languageChosen'

/**
 * Keeps the theme, size or language in the user's configuration, so they follow the user to any browser:
 * track1 puts them into the cookies when the user signs in. The cookie stays the local copy; a refusal
 * (the account admin has nowhere to keep them) changes nothing on the screen.
 */
export const saveUiSettings = (change: IUiSettingsChange): Promise<void> =>
	apiRequestWithAuth<unknown>({
		url: `${BASE_TRACK_API_URL}/v1/users/current/ui`,
		options: {method: 'PUT', body: JSON.stringify(change), headers: {'Content-Type': 'application/json'}},
	}).then(() => undefined, () => undefined)
